// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"83188a52","703":"e49f60a8"}[chunkId] + ".chunk.js";
};